(function () {
  "use strict";
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var initialized = false;
  function safeInit() {
    if (initialized) return;
    initialized = true;
    init();
  }
  document.addEventListener("DOMContentLoaded", safeInit);
  if (document.readyState !== "loading") safeInit();

  function init() {
    initReveal();
    initCounters();
    initStickyNav();
    initHighlightFilters();
    initGallery();
    initFaq();
    initSavingsCalculator();
    initVariantSwatches();
  }

  /* Fade-up reveal for anything with .ev-reveal */
  function initReveal() {
    var items = document.querySelectorAll(".ev-reveal");
    if (!items.length) return;
    if (reducedMotion || !("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Animated number counters for stats */
  function initCounters() {
    var stats = document.querySelectorAll("[data-ev-counter]");
    if (!stats.length) return;
    var animate = function (el) {
      var target = parseFloat(el.getAttribute("data-ev-counter"));
      if (isNaN(target)) return;
      if (reducedMotion) { el.textContent = formatNumber(target); return; }
      var duration = 900, start = null, from = 0;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = formatNumber(from + (target - from) * eased);
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = formatNumber(target);
      }
      requestAnimationFrame(step);
    };
    var formatNumber = function (n) {
      return Number.isInteger(target(n)) ? Math.round(n).toString() : n.toFixed(1);
      function target(v) { return v; }
    };
    if (!("IntersectionObserver" in window)) {
      stats.forEach(animate);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animate(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    stats.forEach(function (el) { io.observe(el); });
  }

  /* Sticky nav: highlight active section on scroll, smooth scroll on click */
  function initStickyNav() {
    var nav = document.querySelector("[data-ev-nav]");
    if (!nav) return;
    var links = nav.querySelectorAll(".ev-nav__link");
    var sections = [];
    links.forEach(function (link) {
      var id = link.getAttribute("href").replace("#", "");
      var section = document.getElementById(id);
      if (section) sections.push({ link: link, section: section });
      link.addEventListener("click", function (e) {
        e.preventDefault();
        if (section) section.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
      });
    });
    if (!sections.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var match = sections.find(function (s) { return s.section === entry.target; });
        if (!match) return;
        if (entry.isIntersecting) {
          links.forEach(function (l) { l.classList.remove("is-active"); });
          match.link.classList.add("is-active");
        }
      });
    }, { rootMargin: "-45% 0px -45% 0px" });
    sections.forEach(function (s) { io.observe(s.section); });
  }

  /* Highlights category filter */
  function initHighlightFilters() {
    var wrap = document.querySelector("[data-ev-highlight-filters]");
    if (!wrap) return;
    var buttons = wrap.querySelectorAll(".ev-filter");
    var cards = document.querySelectorAll("[data-ev-highlight-card]");
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        buttons.forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        var cat = btn.getAttribute("data-filter");
        cards.forEach(function (card) {
          var show = cat === "all" || card.getAttribute("data-category") === cat;
          card.style.display = show ? "" : "none";
        });
      });
    });
  }

  /* Gallery lightbox + swipe scroll (native scroll-snap handles swipe) */
  function initGallery() {
    var items = document.querySelectorAll("[data-ev-gallery-item]");
    var lightbox = document.querySelector("[data-ev-lightbox]");
    if (!items.length || !lightbox) return;
    var content = lightbox.querySelector("[data-ev-lightbox-content]");
    var closeBtn = lightbox.querySelector(".ev-lightbox__close");

    items.forEach(function (item) {
      item.addEventListener("click", function () {
        var html = item.getAttribute("data-full");
        content.innerHTML = html || item.innerHTML;
        lightbox.classList.add("is-open");
      });
    });
    function close() {
      lightbox.classList.remove("is-open");
      content.innerHTML = "";
    }
    if (closeBtn) closeBtn.addEventListener("click", close);
    lightbox.addEventListener("click", function (e) { if (e.target === lightbox) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* Accessible FAQ accordion */
  function initFaq() {
    var items = document.querySelectorAll("[data-ev-faq-item]");
    items.forEach(function (item) {
      var btn = item.querySelector(".ev-faq__question");
      var answer = item.querySelector(".ev-faq__answer");
      if (!btn || !answer) return;
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        items.forEach(function (other) {
          other.classList.remove("is-open");
          other.querySelector(".ev-faq__question").setAttribute("aria-expanded", "false");
          other.querySelector(".ev-faq__answer").style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  }

  /* Savings calculator */
  function initSavingsCalculator() {
    var calc = document.querySelector("[data-ev-savings]");
    if (!calc) return;
    var slider = calc.querySelector("[data-ev-savings-slider]");
    var kmLabel = calc.querySelector("[data-ev-savings-km-label]");
    var config = {};
    try { config = JSON.parse(calc.getAttribute("data-config") || "{}"); } catch (e) { config = {}; }

    var petrolPrice = parseFloat(config.petrol_price) || 0;
    var petrolMileage = parseFloat(config.petrol_mileage) || 1;
    var elecPrice = parseFloat(config.electricity_price) || 0;
    var evEfficiency = parseFloat(config.ev_efficiency) || 1;

    function currency(n) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "en-IN", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "INR", maximumFractionDigits: 0 }).format(n);
      } catch (e) { return n.toFixed(0); }
    }

    function update() {
      var dailyKm = parseFloat(slider.value) || 0;
      var annualKm = dailyKm * 365;
      var petrolCost = petrolMileage > 0 ? (annualKm / petrolMileage) * petrolPrice : 0;
      var evEnergy = evEfficiency > 0 ? annualKm / evEfficiency : 0;
      var evCost = evEnergy * elecPrice;
      var annualSavings = petrolCost - evCost;
      var monthlySavings = annualSavings / 12;

      if (kmLabel) kmLabel.textContent = dailyKm + " km / day";
      setText(calc, "[data-ev-out='petrol-cost']", currency(petrolCost));
      setText(calc, "[data-ev-out='ev-cost']", currency(evCost));
      setText(calc, "[data-ev-out='annual-savings']", currency(annualSavings));
      setText(calc, "[data-ev-out='monthly-savings']", currency(monthlySavings));
    }
    function setText(root, sel, val) {
      var el = root.querySelector(sel);
      if (el) el.textContent = val;
    }
    if (slider) {
      slider.addEventListener("input", update);
      update();
    }
  }

  /* Variant color swatches -> update selected state + sync every add-to-cart /
     buy-now form on the page (hero form and mobile sticky form) */
  function initVariantSwatches() {
    var wrap = document.querySelector("[data-ev-variant-swatches]");
    if (!wrap) return;
    var swatches = wrap.querySelectorAll(".ev-hero__variant");
    swatches.forEach(function (swatch) {
      swatch.addEventListener("click", function () {
        swatches.forEach(function (s) { s.classList.remove("is-selected"); });
        swatch.classList.add("is-selected");
        var variantId = swatch.getAttribute("data-variant-id");
        if (!variantId) return;
        var inputs = document.querySelectorAll(".ev-pdp [data-ev-variant-input]");
        inputs.forEach(function (input) {
          input.value = variantId;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }
})();
